// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2on-a","content":"styles_content__2s_3_","tableWrap":"styles_tableWrap__1tbEW"};